import React, { Suspense, lazy, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./layout.css";
import SidebarData from "../Sidebar/Sidebar";

import { clearItems } from "../../Pages/CommonAppRedux/ShortcutRedux/shortcutItemSlice";
import {
  removeAllNavbarTab,
  removeInactiveNavbarTab,
  removeNavbarTab,
  setActiveTab,
} from "../../Pages/CommonAppRedux/Layout/layoutSlice";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const Modal = lazy(() => import("../Modal/Modal"));
const ItemListing = lazy(() => import("../ShortcutModals/ItemListing"));

const Layout = ({ children }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [openItemListModal, setOpenItemListModal] = useState(false);
  const { navbarTabs, activeTab } = useSelector((state) => state.layout);

  const [showDropdown, setShowDropdown] = useState(false);
  const handleKeyDown = (event) => {
    if (event.key === "Escape" && openItemListModal) {
      dispatch(clearItems());
      setOpenItemListModal(false);
    } else if (event.ctrlKey && event.key === "i") {
      event.preventDefault();
      setOpenItemListModal(true);
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  });

  const collapsed = useSelector((state) => state.layout.collapsed);

  const linkTabsWrapperStyle = {
    width: collapsed ? "86vw" : "78vw", // Adjust based on collapsed state
  };

  const mainContentStyle = {
    width: collapsed ? "calc(100% - 80px)" : "calc(100% - var(--sidebar-width))", // Adjust based on collapsed state
    height: "100vh",
    background: "#f8f9fa",
    transition: "all 0.4s",
    padding: "0px 16px",
    position: "absolute", // Changed from fixed to absolute to avoid layout conflict
    right: 0,
    visibility: openItemListModal ? "hidden" : "visible", // Manage visibility instead of display: none
  };
  const handleScroll = (type) => {
    const scrollableContainer = document.querySelector(".link-tabs-container");

    // Scroll by 100px in the specified direction
    const scrollAmount = 320;
    scrollableContainer.scrollBy({
      left: type === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth", // Smooth scrolling when button is clicked
    });
  };

  return (
    <>
      <div id="layout-wrapper" className="d-flex">
        <div style={{ zIndex: 20 }}>
          <SidebarData />
        </div>

        <div className="main-content" style={mainContentStyle}>
          <div className="link-tabs-wrapper">
            <div className="close-button-container">
              {/* Dropdown */}
              <div className="dropdown custom-dropdown">
                <button
                  type="button"
                  id="close-dropdown"
                  aria-haspopup="true"
                  aria-expanded={showDropdown}
                  className="dropdown-toggle-btn"
                  onClick={() => setShowDropdown((prev) => !prev)}
                >
                  Close
                </button>
                {showDropdown && (
                  <ul className={`dropdown-menu ${showDropdown ? "show" : ""}`} aria-labelledby="close-dropdown">
                    <li>
                      <button
                        className="dropdown-item"
                        onClick={() => {
                          dispatch(removeAllNavbarTab());
                          setShowDropdown(false); // Close dropdown
                          history.push("/");
                        }}
                        disabled={navbarTabs?.length === 0}
                      >
                        Close All
                      </button>
                    </li>
                    <li>
                      <button
                        className="dropdown-item"
                        onClick={() => {
                          setShowDropdown((prev) => !prev); // Close dropdown

                          if (activeTab) {
                            dispatch(removeInactiveNavbarTab(activeTab?.name));
                          }
                        }}
                        disabled={!activeTab || navbarTabs?.length === 0}
                      >
                        Close Other
                      </button>
                    </li>
                  </ul>
                )}
              </div>

              {/* Scroll Buttons */}
              <button
                type="button"
                className="link-tabs-previous"
                disabled={navbarTabs?.length === 0}
                onClick={() => handleScroll("left")}
              >
                <FaChevronLeft />
              </button>
            </div>

            <div className="link-tabs-container" style={linkTabsWrapperStyle}>
              {navbarTabs?.length >= 0 &&
                navbarTabs?.map((tab, i) => (
                  <button
                    key={tab?.name}
                    type="button"
                    onClick={() => {
                      dispatch(setActiveTab(tab)); // use full path stored
                      history.push(tab.link); // go to the actual path like /sale-order/create
                    }}
                    className={`link-tab ${activeTab?.name === tab?.name ? "active" : ""}`}
                  >
                    {tab?.name?.length < 10 ? tab?.name : `${tab.name?.substring(0, 10)}...`}
                    <span
                      className="close-icon"
                      onClick={(e) => {
                        e.stopPropagation();
                        // If the tab being closed is the active tab, set the next available tab as active
                        if (tab?.name === activeTab?.name) {
                          const nextTab = navbarTabs.find((t) => t.name !== tab.name);

                          if (nextTab) {
                            dispatch(removeNavbarTab(tab?.name));
                            dispatch(setActiveTab(nextTab));

                            history.push(nextTab.link); // Redirecting to the next tab
                          } else {
                            // If no next tab is available, clear the active tab and redirect to home
                            dispatch(removeNavbarTab(tab?.name));
                            dispatch(setActiveTab(null));
                            history.push("/"); // If no other tabs are available, redirect to home
                          }
                        } else dispatch(removeNavbarTab(tab?.name));
                      }}
                    >
                      X
                    </span>
                  </button>
                ))}
            </div>
            <button
              type="button"
              className="link-tabs-next"
              disabled={navbarTabs?.length === 0 ? true : false}
              onClick={() => handleScroll("right")}
            >
              <FaChevronRight />
            </button>
          </div>
          <div className="page-content">
            <div className="container-fluid p-0">{children}</div>
          </div>
        </div>
      </div>
      {openItemListModal && (
        <Suspense fallback={<div></div>}>
          <Modal
            showModal={openItemListModal}
            setShowModal={setOpenItemListModal}
            header={"Item List"}
            size={"modal-lg"}
          >
            <ItemListing />
          </Modal>
        </Suspense>
      )}
    </>
  );
};

export default Layout;
